<template>
  <div class="mfc-container">
    <div class="mt-3 mb-2">
      <b-button
        v-for="(label, idx) in $t('maemul_type')"
        variant="white" size="sm"
        :pressed="checkMF($c.MAEMUL_TYPE_MAP_REVERSE[[label]])"
        @click="() => {toggleMF($c.MAEMUL_TYPE_MAP_REVERSE[[label]])}"
        :key="idx">{{label}}</b-button>
    </div>
    <h6 style="text-align: right"><small>{{$t('map.multi_selection')}}</small></h6>
  </div>
</template>

<script>
export default {
  name: 'MFSiteType',
  methods: {
    checkCategory: function(val) {
      return this.$store.getters.filter.site_type == val;
    },
    checkMF: function(val) {
      let flts = (this.$store.getters.filter.maemul_type == '' ? [] :
        this.$store.getters.filter.maemul_type.split(','));
      if (val == '')
        return (flts.length == 0);
      else
        return (flts.indexOf(val) != -1);
    },
    toggleMF: function (val) {
      if (val == '') {
        this.$store.commit('setFilter', {maemul_type: ''});
        return;
      }
      var flts = (this.$store.getters.filter.maemul_type == '' ? [] :
        this.$store.getters.filter.maemul_type.split(','));
      var idx = flts.indexOf(val);
      if (idx != -1)
        flts.splice(idx, 1);
      else
        flts.push(val);
      this.$store.commit('setFilter', {maemul_type: flts.join(',')});
    },
  },
}
</script>

<style scoped lang="scss">
  @import '../../../assets/css/_vars.scss';
  h6 {
    font-size: $fs_22;
    font-family: $korean_gd_17_r;
  }
  h6>small {
    //color: #ccc9c9;
    color: $trading1;
    font-size: $fs_18;
    font-family: $korean_gd_13_r;
  }
  div.mfc-container {
    padding: 20px 40px;
    background-color: white;
    width: 100%;
    margin: auto;
  }
  button {
    margin-right: 8px;
    font-size: $fs_20;
    font-family: $korean_gd_14_r;
    border-width: 0.5px;
    border-radius: 5px;
    border-color: #eeeeef;
    height: 50px;
    padding: .375rem .75rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/controls/mf/MFSiteType.vue